var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg58(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(-3 -4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.31,
    cy: 23.48,
    r: 19.49,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7BC8FF",
    d: "M23.31 39.66A16.2 16.2 0 0 1 7.14 23.48 16.2 16.2 0 0 1 23.3 7.31a16.2 16.2 0 0 1 16.17 16.17A16.2 16.2 0 0 1 23.3 39.66zm0-29.7A13.54 13.54 0 0 0 9.79 23.48c0 7.46 6.06 13.53 13.52 13.53a13.54 13.54 0 0 0 0-27.05z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.23,
    cy: 40.22,
    fill: "#0B3E86",
    rx: 4.57,
    ry: 5.78
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B3E86",
    d: "M33.92 27.8a3.42 3.42 0 0 1 6.83 0v5.82h3.32V27.8a6.74 6.74 0 0 0-13.46 0v5.82h3.31V27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7BC8FF",
    d: "M44.95 32.32H29.72c-1 0-1.82.82-1.82 1.82v10.87c0 1 .82 1.82 1.82 1.82h15.25c1 0 1.82-.82 1.82-1.82V34.14c0-1-.82-1.82-1.84-1.82zm-6.12 10.5h-2.99l.6-3.17a1.8 1.8 0 0 1-.88-1.52 1.78 1.78 0 0 1 3.56 0c0 .65-.35 1.2-.88 1.52l.6 3.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B3E86",
    d: "M36.99 32.1l-2.95-.4a13.57 13.57 0 0 1-6.65 4.68c.01.97.03 1.93.06 2.74a16.22 16.22 0 0 0 9.54-7.02z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg58);
export default __webpack_public_path__ + "static/media/5.8.742a33acc2ed9d33f70aa0d094190d83.svg";
export { ForwardRef as ReactComponent };